import CardHelp from '../_common/components/CardDashboard/CardHelp'
import { AppPage } from '../_common/components/app-page'
import { C, F } from '../_common/layout'
import { Fragment, h } from "preact";
import { Select } from '../_common/forms/components/components'
import { isSpanishUser } from '../_common/utils/getLang'
import { t } from '../_i18n'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'
import { useState } from 'preact/hooks'

const isSameFormativeZone = (academicPrograms) => {
    let formativeZone = academicPrograms[0].formative_zone_code
    return academicPrograms.every(ap => ap.formative_zone_code === formativeZone)
}

const academicInfo = () => ({
    es: {
        CAT001: {
            on_site_classes: {
                title: t('Normativa de las clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-de-las-clases-presenciales'
            },
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normas-de-convivencia'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/gu%C3%ADa-de-orientaci%C3%B3n-para-el-alumnado-ciclos-semestrales-normativa-antigua'
            },
            academic_calendar_s1: {
                title: `${t('Calendario académico')} (Semestre 1)`,
                url: 'https://drive.google.com/file/d/1UMCy_eN0TtAD36QEYP4Qbx1EaUTU_Mhf/view?usp=sharing'
            },
            academic_calendar_s2: {
                title: `${t('Calendario académico')} (Semestre 2)`,
                url: 'https://ilerna-my.sharepoint.com/:b:/g/personal/ambatista_ilerna_com1/IQBUHS1ogNloSKpdXo_eHT62AUbS7hiwuUfMUqnDZP3m38o?e=8isZMi'
            }
        },
        CAT002: {
            on_site_classes: {
                title: t('Normativa de las clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-de-las-clases-presenciales'
            },
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normas-de-convivencia'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/gu%C3%ADa-de-orientaci%C3%B3n-para-el-alumnado-ciclos-semestrales-normativa-antigua'
            },
            academic_calendar_s1: {
                title: `${t('Calendario académico')} (Semestre 1)`,
                url: 'https://drive.google.com/file/d/1UMCy_eN0TtAD36QEYP4Qbx1EaUTU_Mhf/view?usp=sharing'
            },
            academic_calendar_s2: {
                title: `${t('Calendario académico')} (Semestre 2)`,
                url: 'https://ilerna-my.sharepoint.com/:b:/g/personal/ambatista_ilerna_com1/IQBUHS1ogNloSKpdXo_eHT62AUbS7hiwuUfMUqnDZP3m38o?e=8isZMi'
            }
        },
        CAT2122: {
            on_site_classes: {
                title: t('Normativa de las clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-de-las-clases-presenciales'
            },
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normas-de-convivencia'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/gu%C3%ADa-de-orientaci%C3%B3n-para-el-alumnado-ciclos-semestrales-normativa-antigua'
            },
            academic_calendar_s1: {
                title: `${t('Calendario académico')} (Semestre 1)`,
                url: 'https://drive.google.com/file/d/1UMCy_eN0TtAD36QEYP4Qbx1EaUTU_Mhf/view?usp=sharing'
            },
            academic_calendar_s2: {
                title: `${t('Calendario académico')} (Semestre 2)`,
                url: 'https://ilerna-my.sharepoint.com/:b:/g/personal/ambatista_ilerna_com1/IQBUHS1ogNloSKpdXo_eHT62AUbS7hiwuUfMUqnDZP3m38o?e=8isZMi'
            }
        },
        CAT2425: {
            on_site_classes: {
                title: t('Normativa de las clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-de-las-clases-presenciales'
            },
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normas-de-convivencia'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/gu%C3%ADa-de-orientaci%C3%B3n-para-el-alumno-ciclos-semestrales-nueva-normativa'
            },
            academic_calendar_s1: {
                title: `${t('Calendario académico')} (Semestre 1)`,
                url: 'https://drive.google.com/file/d/1UMCy_eN0TtAD36QEYP4Qbx1EaUTU_Mhf/view?usp=sharing'
            },
            academic_calendar_s2: {
                title: `${t('Calendario académico')} (Semestre 2)`,
                url: 'https://ilerna-my.sharepoint.com/:b:/g/personal/ambatista_ilerna_com1/IQBUHS1ogNloSKpdXo_eHT62AUbS7hiwuUfMUqnDZP3m38o?e=8isZMi'
            }
        },
        CAT2425_SPECIAL: {
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1lDzCU4Y2nmEvutUcVCSL89fEnLtEH8sc/view?usp=sharing'
            }
        },
        MAD001: {
            on_site_classes: {
                title: t('Normativa de las clases presenciales'),
                url: '#'
            },
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normas-de-convivencia'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/gu%C3%ADa-de-orientaci%C3%B3n-para-el-alumnado-ciclos-anuales'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h3-L64yjaucwrDFumEDwFqroPSfdHz8l/view?usp=sharing'
            }
        },
        MAD002: {
            on_site_classes: {
                title: t('Normativa de las clases presenciales'),
                url: '#'
            },
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normas-de-convivencia'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/gu%C3%ADa-de-orientaci%C3%B3n-para-el-alumnado-ciclos-anuales'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h3-L64yjaucwrDFumEDwFqroPSfdHz8l/view?usp=sharing'
            }
        },
        MAD2425: {
            on_site_classes: {
                title: t('Normativa de las clases presenciales'),
                url: '#'
            },
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normas-de-convivencia'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/gu%C3%ADa-de-orientaci%C3%B3n-para-el-alumnado-ciclos-anuales'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h3-L64yjaucwrDFumEDwFqroPSfdHz8l/view?usp=sharing'
            }
        }
    },
    fr: {
        CAT001: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29514354035357-R%C3%A8gles-de-vie-collective'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29917629650845-Guide-d-Orientation-pour-les-%C3%89tudiants#'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h8Ubu__aGWOUkKSCYfLKG1DAoXjaZ4Km/view'
            }
        },
        CAT002: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29514354035357-R%C3%A8gles-de-vie-collective'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29917629650845-Guide-d-Orientation-pour-les-%C3%89tudiants#'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h8Ubu__aGWOUkKSCYfLKG1DAoXjaZ4Km/view'
            }
        },
        CAT2122: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29514354035357-R%C3%A8gles-de-vie-collective'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29917629650845-Guide-d-Orientation-pour-les-%C3%89tudiants#'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h8Ubu__aGWOUkKSCYfLKG1DAoXjaZ4Km/view'
            }
        },
        CAT2425: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29514354035357-R%C3%A8gles-de-vie-collective'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29917629650845-Guide-d-Orientation-pour-les-%C3%89tudiants#'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h8Ubu__aGWOUkKSCYfLKG1DAoXjaZ4Km/view'
            }
        },
        CAT2425_SPECIAL: {
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1lDzCU4Y2nmEvutUcVCSL89fEnLtEH8sc/view?usp=sharing'
            }
        },
        MAD001: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29514354035357-R%C3%A8gles-de-vie-collective'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29917629650845-Guide-d-Orientation-pour-les-%C3%89tudiants#'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h8Ubu__aGWOUkKSCYfLKG1DAoXjaZ4Km/view'
            }
        },
        MAD002: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29514354035357-R%C3%A8gles-de-vie-collective'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29917629650845-Guide-d-Orientation-pour-les-%C3%89tudiants#'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h8Ubu__aGWOUkKSCYfLKG1DAoXjaZ4Km/view'
            }
        },
        MAD2425: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29514354035357-R%C3%A8gles-de-vie-collective'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29917629650845-Guide-d-Orientation-pour-les-%C3%89tudiants#'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1h8Ubu__aGWOUkKSCYfLKG1DAoXjaZ4Km/view'
            }
        }
    },
    it: {
        CAT001: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29750001217693-Normativa-di-convivenza-collettiva'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29755163300509-Guida-di-Orientamento-per-gli-Studenti'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1bhohR5TzY2GLQ4yI95upsyNEIZ3KdpR2/view?usp=sharing'
            }
        },
        CAT002: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29750001217693-Normativa-di-convivenza-collettiva'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29755163300509-Guida-di-Orientamento-per-gli-Studenti'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1bhohR5TzY2GLQ4yI95upsyNEIZ3KdpR2/view?usp=sharing'
            }
        },
        CAT2122: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29750001217693-Normativa-di-convivenza-collettiva'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29755163300509-Guida-di-Orientamento-per-gli-Studenti'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1bhohR5TzY2GLQ4yI95upsyNEIZ3KdpR2/view?usp=sharing'
            }
        },
        CAT2425: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29750001217693-Normativa-di-convivenza-collettiva'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29755163300509-Guida-di-Orientamento-per-gli-Studenti'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1bhohR5TzY2GLQ4yI95upsyNEIZ3KdpR2/view?usp=sharing'
            }
        },
        CAT2425_SPECIAL: {
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1lDzCU4Y2nmEvutUcVCSL89fEnLtEH8sc/view?usp=sharing'
            }
        },
        MAD001: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29750001217693-Normativa-di-convivenza-collettiva'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29755163300509-Guida-di-Orientamento-per-gli-Studenti'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1bhohR5TzY2GLQ4yI95upsyNEIZ3KdpR2/view?usp=sharing'
            }
        },
        MAD002: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29750001217693-Normativa-di-convivenza-collettiva'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29755163300509-Guida-di-Orientamento-per-gli-Studenti'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1bhohR5TzY2GLQ4yI95upsyNEIZ3KdpR2/view?usp=sharing'
            }
        },
        MAD2425: {
            coexistence_rules: {
                title: t('Normas de convivencia'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29750001217693-Normativa-di-convivenza-collettiva'
            },
            student_orientation_guide: {
                title: `${t('Guía de orientación para el alumno')}`,
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29755163300509-Guida-di-Orientamento-per-gli-Studenti'
            },
            academic_calendar: {
                title: `${t('Calendario académico')}`,
                url: 'https://drive.google.com/file/d/1bhohR5TzY2GLQ4yI95upsyNEIZ3KdpR2/view?usp=sharing'
            }
        }
    }
})

const getAcademicInfoBySemester = (lang, formativeZone, semesters) => {
  const zoneInfo = academicInfo()?.[lang]?.[formativeZone]
  if (!zoneInfo) return {}

  const result = { ...zoneInfo }
  console.log('Semestre: ', result)

  if (!semesters.includes(1)) delete result.academic_calendar_s1
  if (!semesters.includes(2)) delete result.academic_calendar_s2

  return {
    [lang]: {
      [formativeZone]: result
    }
  }
}

const methodology = () => ({
    es: {
        CAT001: {
            methodology: {
                title: t('Metodología'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/metodolog%C3%ADa-semestral',
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/ex%C3%A1menes-semestrales-normativa-antigua'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/clases-presenciales-ciclos-semestrales'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%A1lculo-de-notas',
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-revisi%C3%B3n-de-examen'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convocatoria-semestral'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/trabajo-final-de-ciclo-ciclos-semestrales-normativa-antigua'
            }
        },
        CAT002: {
            methodology: {
                title: t('Metodología'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/metodolog%C3%ADa-semestral',
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/ex%C3%A1menes-semestrales-normativa-antigua'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/clases-presenciales-ciclos-semestrales'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%A1lculo-de-notas',
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-revisi%C3%B3n-de-examen'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convocatoria-semestral'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/trabajo-final-de-ciclo-ciclos-semestrales-normativa-antigua'
            }
        },
        CAT2122: {
            methodology: {
                title: t('Metodología'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/metodolog%C3%ADa-semestral',
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/ex%C3%A1menes-semestrales-normativa-antigua'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/clases-presenciales-ciclos-semestrales'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%A1lculo-de-notas',
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-revisi%C3%B3n-de-examen'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convocatoria-semestral'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/trabajo-final-de-ciclo-ciclos-semestrales-normativa-antigua'
            }
        },
        CAT2425: {
            methodology: {
                title: t('Metodología'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/metodolog%C3%ADa-semestral',
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/ex%C3%A1menes-semestrales'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/clases-presenciales-ciclos-semestrales'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%A1lculo-de-notas',
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-revisi%C3%B3n-de-examen'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convocatoria-semestral'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/trabajo-final-de-ciclo-ciclos-semestral-nueva-normativa'
            }
        },
        MAD001: {
            methodology: {
                title: t('Metodología'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/en-ilerna-valoramos-positivamente-el-trabajo-y-el-esfuerzo-constante-de-los-onliners-por-eso-apostamos-por-una-evaluaci%C3%B3n-continua-pruebas-de-evaluaci%C3%B3n-continua-pecs-son-las-actividades-que-tendr%C3%A1s-que-llevar-a-cabo-a-lo-largo-de-todo-el-curso-y-que-se-realizan-bas%C3%A1ndonos-en-el-pla',
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/ex%C3%A1menes-anuales'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/clases-presenciales-ciclos-anuales'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%A1lculo-de-notas',
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-revisi%C3%B3n-de-examen'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convocatoria-anual'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/trabajo-final-de-ciclo-ciclos-anuales-5-11-2025'
            }
        },
        MAD002: {
            methodology: {
                title: t('Metodología'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/en-ilerna-valoramos-positivamente-el-trabajo-y-el-esfuerzo-constante-de-los-onliners-por-eso-apostamos-por-una-evaluaci%C3%B3n-continua-pruebas-de-evaluaci%C3%B3n-continua-pecs-son-las-actividades-que-tendr%C3%A1s-que-llevar-a-cabo-a-lo-largo-de-todo-el-curso-y-que-se-realizan-bas%C3%A1ndonos-en-el-pla',
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/ex%C3%A1menes-anuales'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/clases-presenciales-ciclos-anuales'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%A1lculo-de-notas',
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-revisi%C3%B3n-de-examen'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convocatoria-anual'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/trabajo-final-de-ciclo-ciclos-anuales-5-11-2025'
            }
        },
        MAD2425: {
            methodology: {
                title: t('Metodología'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/en-ilerna-valoramos-positivamente-el-trabajo-y-el-esfuerzo-constante-de-los-onliners-por-eso-apostamos-por-una-evaluaci%C3%B3n-continua-pruebas-de-evaluaci%C3%B3n-continua-pecs-son-las-actividades-que-tendr%C3%A1s-que-llevar-a-cabo-a-lo-largo-de-todo-el-curso-y-que-se-realizan-bas%C3%A1ndonos-en-el-pla',
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/ex%C3%A1menes-anuales'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/clases-presenciales-ciclos-anuales'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%A1lculo-de-notas',
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-revisi%C3%B3n-de-examen'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convocatoria-anual'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/trabajo-final-de-ciclo-ciclos-anuales-5-11-2025'
            }
        }
    },
    fr: {
        CAT001: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563546577309-M%C3%A9thodologie'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563492631325-Cours-en-pr%C3%A9sentiel'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563456069533-Session-annuelle'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563531344285-Examens'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563474536733-Calcul-des-notes'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563473881885-Demande-de-r%C3%A9vision-d-examen'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563422883741-Travail-final-de-cycle'
            }
        },
        CAT002: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563546577309-M%C3%A9thodologie'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563492631325-Cours-en-pr%C3%A9sentiel'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563456069533-Session-annuelle'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563531344285-Examens'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563474536733-Calcul-des-notes'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563473881885-Demande-de-r%C3%A9vision-d-examen'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563422883741-Travail-final-de-cycle'
            }
        },
        CAT2122: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563546577309-M%C3%A9thodologie'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563492631325-Cours-en-pr%C3%A9sentiel'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563456069533-Session-annuelle'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563531344285-Examens'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563474536733-Calcul-des-notes'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563473881885-Demande-de-r%C3%A9vision-d-examen'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563422883741-Travail-final-de-cycle'
            }
        },
        CAT2425: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563546577309-M%C3%A9thodologie'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563492631325-Cours-en-pr%C3%A9sentiel'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563456069533-Session-annuelle'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563531344285-Examens'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563474536733-Calcul-des-notes'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563473881885-Demande-de-r%C3%A9vision-d-examen'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563422883741-Travail-final-de-cycle'
            }
        },
        MAD001: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563546577309-M%C3%A9thodologie'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563492631325-Cours-en-pr%C3%A9sentiel'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563456069533-Session-annuelle'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563531344285-Examens'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563474536733-Calcul-des-notes'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563473881885-Demande-de-r%C3%A9vision-d-examen'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563422883741-Travail-final-de-cycle'
            }
        },
        MAD002: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563546577309-M%C3%A9thodologie'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563492631325-Cours-en-pr%C3%A9sentiel'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563456069533-Session-annuelle'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563531344285-Examens'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563474536733-Calcul-des-notes'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563473881885-Demande-de-r%C3%A9vision-d-examen'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563422883741-Travail-final-de-cycle'
            }
        },
        MAD2425: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563546577309-M%C3%A9thodologie'
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563492631325-Cours-en-pr%C3%A9sentiel'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563456069533-Session-annuelle'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563531344285-Examens'
            },
            grade_calculation: {
                title: t('Cálculo de notas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563474536733-Calcul-des-notes'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563473881885-Demande-de-r%C3%A9vision-d-examen'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563422883741-Travail-final-de-cycle'
            }
        }
    },
    it: {
        CAT001: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756046145949-Metodologia',
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756556365853-Lezioni-presenziali'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757542449565-Sessione-annuale'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756293356189-Esami'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757378846749-Richiesta-di-revisione-dell-esame'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760026083869-Progetto-intermodulare'
            }
        },
        CAT002: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756046145949-Metodologia',
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756556365853-Lezioni-presenziali'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757542449565-Sessione-annuale'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756293356189-Esami'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757378846749-Richiesta-di-revisione-dell-esame'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760026083869-Progetto-intermodulare'
            }
        },
        CAT2122: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756046145949-Metodologia',
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756556365853-Lezioni-presenziali'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757542449565-Sessione-annuale'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756293356189-Esami'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757378846749-Richiesta-di-revisione-dell-esame'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760026083869-Progetto-intermodulare'
            }
        },
        CAT2425: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756046145949-Metodologia',
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756556365853-Lezioni-presenziali'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757542449565-Sessione-annuale'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756293356189-Esami'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757378846749-Richiesta-di-revisione-dell-esame'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760026083869-Progetto-intermodulare'
            }
        },
        MAD001: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756046145949-Metodologia',
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756556365853-Lezioni-presenziali'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757542449565-Sessione-annuale'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756293356189-Esami'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757378846749-Richiesta-di-revisione-dell-esame'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760026083869-Progetto-intermodulare'
            }
        },
        MAD002: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756046145949-Metodologia',
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756556365853-Lezioni-presenziali'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757542449565-Sessione-annuale'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756293356189-Esami'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757378846749-Richiesta-di-revisione-dell-esame'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760026083869-Progetto-intermodulare'
            }
        },
        MAD2425: {
            methodology: {
                title: t('Metodología'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756046145949-Metodologia',
            },
            on_site_clases: {
                title: t('Clases presenciales'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756556365853-Lezioni-presenziali'
            },
            exam_convocations: {
                title: t('Convocatorias'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757542449565-Sessione-annuale'
            },
            exams: {
                title: t('Exámenes'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29756293356189-Esami'
            },
            exam_revision: {
                title: t('Solicitud de revisión de examen'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29757378846749-Richiesta-di-revisione-dell-esame'
            },
            capstone_project: {
                title: t('Trabajo final de ciclo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760026083869-Progetto-intermodulare'
            }
        }
    }
})

const campus = () => ({
    es: {
        CAT001: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%B3mo-acceder-y-navegar-por-el-campus-virtual',
            }
        },
        CAT002: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%B3mo-acceder-y-navegar-por-el-campus-virtual',
            }
        },
        CAT2122: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%B3mo-acceder-y-navegar-por-el-campus-virtual',
            }
        },
        CAT2425: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%B3mo-acceder-y-navegar-por-el-campus-virtual',
            }
        },
        MAD001: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%B3mo-acceder-y-navegar-por-el-campus-virtual',
            }
        },
        MAD002: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%B3mo-acceder-y-navegar-por-el-campus-virtual',
            }
        },
        MAD2425: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/c%C3%B3mo-acceder-y-navegar-por-el-campus-virtual',
            }
        }
    },
    fr: {
        CAT001: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563248134685-Comment-acc%C3%A9der-et-naviguer-sur-le-Campus-Virtuel'
            }
        },
        CAT002: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563248134685-Comment-acc%C3%A9der-et-naviguer-sur-le-Campus-Virtuel'
            }
        },
        CAT2122: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563248134685-Comment-acc%C3%A9der-et-naviguer-sur-le-Campus-Virtuel'
            }
        },
        CAT2425: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563248134685-Comment-acc%C3%A9der-et-naviguer-sur-le-Campus-Virtuel'
            }
        },
        MAD001: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563248134685-Comment-acc%C3%A9der-et-naviguer-sur-le-Campus-Virtuel'
            }
        },
        MAD002: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563248134685-Comment-acc%C3%A9der-et-naviguer-sur-le-Campus-Virtuel'
            }
        },
        MAD2425: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/14563248134685-Comment-acc%C3%A9der-et-naviguer-sur-le-Campus-Virtuel'
            }
        }
    },
    it: {
        CAT001: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29836344298141-Come-accedere-e-navigare-nel-Campus-Virtuale'
            }
        },
        CAT002: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29836344298141-Come-accedere-e-navigare-nel-Campus-Virtuale'
            }
        },
        CAT2122: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29836344298141-Come-accedere-e-navigare-nel-Campus-Virtuale'
            }
        },
        CAT2425: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29836344298141-Come-accedere-e-navigare-nel-Campus-Virtuale'
            }
        },
        MAD001: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29836344298141-Come-accedere-e-navigare-nel-Campus-Virtuale'
            }
        },
        MAD002: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29836344298141-Come-accedere-e-navigare-nel-Campus-Virtuale'
            }
        },
        MAD2425: {
            campus: {
                title: t('El campus de ILERNA Online'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29836344298141-Come-accedere-e-navigare-nel-Campus-Virtuale'
            }
        }
    }
})

const fct = () => ({
    es: {
        CAT001: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-cursar-la-formaci%C3%B3n-en-centros-de-trabajo',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-fct-antigua',
            }
        },
        CAT002: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-cursar-la-formaci%C3%B3n-en-centros-de-trabajo',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-fct-antigua',
            }
        },
        CAT002_SPECIAL: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://soporte.ilerna.es/hc/es-es/articles/11547333260573-Requisitos-para-cursar-la-Formaci%C3%B3n-en-Centros-de-Trabajo',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://drive.google.com/file/d/184Il7puJBX65eDbuODjfKcCtsLbBCdKt/view?usp=sharing',
            }
        },
        CAT2122: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-cursar-la-formacion-en-centros-de-trabajo',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://ilerna.zohodesk.eu/portal/es/kb/articles/normativa-fct-antigua',
            }
        },
        CAT2122_SPECIAL: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-cursar-la-formacion-en-centros-de-trabajo',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://apifct.ilernaonline.com/regulations/2122_2p.pdf',
            }
        },
        CAT2425: {
            requirements: {
                title: t('Requisitos para cursar Estancia en la Empresa'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-cursar-estancia-en-la-empresa',
            },
            rules: {
                title: t('Normativa de Estancia en la Empresa'),
                url: 'https://ilerna.zohodesk.eu/portal/es/kb/articles/normativa-estancia-en-la-empresa',
            }
        },
        CAT2425_SPECIAL: {
            requirements: {
                title: t('Requisitos para cursar Estancia en la Empresa'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-cursar-estancia-en-la-empresa',
            },
            rules: {
                title: t('Normativa de Estancia en la Empresa'),
                url: 'https://apifct.ilernaonline.com/regulations/2425_2p.pdf',
            }
        },
        MAD001: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-matricularme-en-fct-de-ciclos-anuales',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-formaci%C3%B3n-en-centros-de-trabajo-mad-5-11-2025',
            }
        },
        MAD002: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-matricularme-en-fct-de-ciclos-anuales',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-formaci%C3%B3n-en-centros-de-trabajo-mad-5-11-2025',
            }
        },
        MAD2425: {
            requirements: {
                title: t('Requisitos para cursar Fase de Formación en la Empresa'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/requisitos-para-cursar-fase-de-formaci%C3%B3n-en-la-empresa-5-11-2025',
            },
            rules: {
                title: t('Normativa de Fase de Formación en la Empresa'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/normativa-fase-de-formaci%C3%B3n-en-la-empresa',
            }
        }
    },
    fr: {
        CAT001: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT002: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT2122: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT2122_SPECIAL: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT2425: {
            requirements: {
                title: t('Requisitos para cursar Estancia en la Empresa'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Estancia en la Empresa'),
                url: '#'
            }
        },
        CAT2425_SPECIAL: {
            requirements: {
                title: t('Requisitos para cursar Estancia en la Empresa'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Estancia en la Empresa'),
                url: '#'
            }
        },
        MAD001: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        MAD002: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29565353048349-Conditions-pour-s-inscrire-dans-la-Formation-en-Centres-de-Travail-stage-entreprise-FCT',
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29584540813469-R%C3%A9glementation-de-la-Formation-en-Centres-de-Travail',
            },
            documents: {
                title: t('Documentos para realizar las prácticas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/31254457043229-Quels-sont-les-documents-n%C3%A9cessaires-%C3%A0-la-r%C3%A9alisation-de-mon-stage',
            }
        },
        MAD2425: {
            requirements: {
                title: t('Requisitos para cursar Fase de Formación en la Empresa'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29565681152669-Pr%C3%A9requis-pour-la-Phase-de-Formation-en-Entreprise',
            },
            rules: {
                title: t('Normativa de Fase de Formación en la Empresa'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29592369810461-R%C3%A8glement-Phase-de-Formation-en-Entreprise',
            },
            documents: {
                title: t('Documentos para realizar las prácticas'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/31254457043229-Quels-sont-les-documents-n%C3%A9cessaires-%C3%A0-la-r%C3%A9alisation-de-mon-stage',
            }
        }
    },
    it: {
        CAT001: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT002: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT2122: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT2122_SPECIAL: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        CAT2425: {
            requirements: {
                title: t('Requisitos para cursar Estancia en la Empresa'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Estancia en la Empresa'),
                url: '#'
            }
        },
        CAT2425_SPECIAL: {
            requirements: {
                title: t('Requisitos para cursar Estancia en la Empresa'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Estancia en la Empresa'),
                url: '#'
            }
        },
        MAD001: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: '#'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: '#'
            }
        },
        MAD002: {
            requirements: {
                title: t('Requisitos para cursar Formación en Centros de Trabajo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29835787918877-Requisiti-per-la-Formazione-nei-Centri-di-Lavoro'
            },
            rules: {
                title: t('Normativa de Formación en Centros de Trabajo'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29840604313245-Normativa-della-Formazione-nei-Centri-di-Lavoro-FCT'
            }
        },
        MAD2425: {
            requirements: {
                title: t('Requisitos para cursar Fase de Formación en la Empresa'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29835965974813-Requisiti-per-la-Fase-di-Formazione-in-Azienda-FFE'
            },
            rules: {
                title: t('Normativa de Fase de Formación en la Empresa'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29841277919901-Normativa-Fase-di-Formazione-in-Azienda'
            }
        }
    }
})

const secretary = () => ({
    es: {
        CAT001: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/qu%C3%A9-documentaci%C3%B3n-debo-aportar-para-formalizar-mi-matr%C3%ADcula',
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convalidaciones',
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/d%C3%B3nde-puedo-solicitar-un-certificado',
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-t%C3%ADtulo',
            }
        },
        CAT002: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/qu%C3%A9-documentaci%C3%B3n-debo-aportar-para-formalizar-mi-matr%C3%ADcula',
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convalidaciones',
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/d%C3%B3nde-puedo-solicitar-un-certificado',
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-t%C3%ADtulo',
            }
        },
        CAT2122: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/qu%C3%A9-documentaci%C3%B3n-debo-aportar-para-formalizar-mi-matr%C3%ADcula',
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convalidaciones',
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/d%C3%B3nde-puedo-solicitar-un-certificado',
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-t%C3%ADtulo',
            }
        },
        CAT2425: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/qu%C3%A9-documentaci%C3%B3n-debo-aportar-para-formalizar-mi-matr%C3%ADcula',
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convalidaciones',
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/d%C3%B3nde-puedo-solicitar-un-certificado',
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-t%C3%ADtulo',
            }
        },
        MAD001: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/qu%C3%A9-documentaci%C3%B3n-debo-aportar-para-formalizar-mi-matr%C3%ADcula',
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convalidaciones',
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/d%C3%B3nde-puedo-solicitar-un-certificado',
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-t%C3%ADtulo',
            }
        },
        MAD002: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/qu%C3%A9-documentaci%C3%B3n-debo-aportar-para-formalizar-mi-matr%C3%ADcula',
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convalidaciones',
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/d%C3%B3nde-puedo-solicitar-un-certificado',
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-t%C3%ADtulo',
            }
        },
        MAD2425: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/qu%C3%A9-documentaci%C3%B3n-debo-aportar-para-formalizar-mi-matr%C3%ADcula',
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/convalidaciones',
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/d%C3%B3nde-puedo-solicitar-un-certificado',
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://centrodeayuda.ilerna.es/portal/es/kb/articles/solicitud-de-t%C3%ADtulo',
            }
        }
    },
    fr: {
        CAT001: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29566842167325-Quels-documents-devez-vous-fournir-pour-finaliser-votre-inscription'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569216603805-O%C3%B9-pouvez-vous-demander-un-certificat'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569303935261-Demande-de-dipl%C3%B4me'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29890066572061-Guide-pour-l-homologation-des-dipl%C3%B4mes'
            }
        },
        CAT002: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29566842167325-Quels-documents-devez-vous-fournir-pour-finaliser-votre-inscription'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569216603805-O%C3%B9-pouvez-vous-demander-un-certificat'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569303935261-Demande-de-dipl%C3%B4me'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29890066572061-Guide-pour-l-homologation-des-dipl%C3%B4mes'
            }
        },
        CAT2122: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29566842167325-Quels-documents-devez-vous-fournir-pour-finaliser-votre-inscription'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569216603805-O%C3%B9-pouvez-vous-demander-un-certificat'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569303935261-Demande-de-dipl%C3%B4me'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29890066572061-Guide-pour-l-homologation-des-dipl%C3%B4mes'
            }
        },
        CAT2425: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29566842167325-Quels-documents-devez-vous-fournir-pour-finaliser-votre-inscription'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569216603805-O%C3%B9-pouvez-vous-demander-un-certificat'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569303935261-Demande-de-dipl%C3%B4me'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29890066572061-Guide-pour-l-homologation-des-dipl%C3%B4mes'
            }
        },
        MAD001: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29566842167325-Quels-documents-devez-vous-fournir-pour-finaliser-votre-inscription'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569216603805-O%C3%B9-pouvez-vous-demander-un-certificat'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569303935261-Demande-de-dipl%C3%B4me'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29890066572061-Guide-pour-l-homologation-des-dipl%C3%B4mes'
            }
        },
        MAD002: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29566842167325-Quels-documents-devez-vous-fournir-pour-finaliser-votre-inscription'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569216603805-O%C3%B9-pouvez-vous-demander-un-certificat'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569303935261-Demande-de-dipl%C3%B4me'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29890066572061-Guide-pour-l-homologation-des-dipl%C3%B4mes'
            }
        },
        MAD2425: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29566842167325-Quels-documents-devez-vous-fournir-pour-finaliser-votre-inscription'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569216603805-O%C3%B9-pouvez-vous-demander-un-certificat'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29569303935261-Demande-de-dipl%C3%B4me'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernafrance.zendesk.com/hc/fr/articles/29890066572061-Guide-pour-l-homologation-des-dipl%C3%B4mes'
            }
        }
    },
    it: {
        CAT001: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760747344925-Quali-documenti-devo-fornire-per-completare-la-mia-iscrizione'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760931126045-Dove-posso-richiedere-un-certificato'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29761241803165-Richiesta-del-diploma'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29920792199453-Guida-per-il-riconoscimento-dei-titoli'
            }
        },
        CAT002: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760747344925-Quali-documenti-devo-fornire-per-completare-la-mia-iscrizione'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760931126045-Dove-posso-richiedere-un-certificato'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29761241803165-Richiesta-del-diploma'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29920792199453-Guida-per-il-riconoscimento-dei-titoli'
            }
        },
        CAT2122: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760747344925-Quali-documenti-devo-fornire-per-completare-la-mia-iscrizione'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760931126045-Dove-posso-richiedere-un-certificato'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29761241803165-Richiesta-del-diploma'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29920792199453-Guida-per-il-riconoscimento-dei-titoli'
            }
        },
        CAT2425: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760747344925-Quali-documenti-devo-fornire-per-completare-la-mia-iscrizione'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760931126045-Dove-posso-richiedere-un-certificato'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29761241803165-Richiesta-del-diploma'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29920792199453-Guida-per-il-riconoscimento-dei-titoli'
            }
        },
        MAD001: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760747344925-Quali-documenti-devo-fornire-per-completare-la-mia-iscrizione'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760931126045-Dove-posso-richiedere-un-certificato'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29761241803165-Richiesta-del-diploma'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29920792199453-Guida-per-il-riconoscimento-dei-titoli'
            }
        },
        MAD002: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760747344925-Quali-documenti-devo-fornire-per-completare-la-mia-iscrizione'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760931126045-Dove-posso-richiedere-un-certificato'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29761241803165-Richiesta-del-diploma'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29920792199453-Guida-per-il-riconoscimento-dei-titoli'
            }
        },
        MAD2425: {
            enrollment_formalization: {
                title: t('Formalización de matrícula'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760747344925-Quali-documenti-devo-fornire-per-completare-la-mia-iscrizione'
            },
            recognitions: {
                title: t('Convalidaciones'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29760931126045-Dove-posso-richiedere-un-certificato'
            },
            certificates: {
                title: t('Certificados'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29761241803165-Richiesta-del-diploma'
            },
            title_request: {
                title: t('Solicitud de título'),
                url: 'https://ilernaitalia.zendesk.com/hc/it/articles/29920792199453-Guida-per-il-riconoscimento-dei-titoli'
            }
        }
    }
})

const Link = ({ to, title }) => <div className='m-top-half'><a href={to} target='_blank'
    className='font-color-149BAB'>{title}</a></div>

const printLinks = (links, formativeZone, lang) => {
    const planSections = links[lang]?.[formativeZone];

    if (!planSections) return null;

    return Object.entries(planSections).map(([key, value]) => {
        const url = value?.url;
        const title = value?.title;

        if (url && url !== '#') {
            return <Link key={key} title={title} to={url} />;
        }

        return null;
    });
}

export default function OnlineArea() {
    const special_academic_programs = [1085, 1159, 1256, 1289]
    const special_academic_big_data_cybersecurity = [1398, 1412, 1413, 1414]

    const { student_meta, lang } = useSelector(state => ({
        student_meta: state.status.student_meta,
        lang: state.lang
    }))

    const history = useHistory()
    //  enrolled_academic_programs -> ever enrolled
    const academicPrograms = student_meta.enrolled_academic_programs?.filter(ap => ap.formative_zone).map(ap => ({
        name: `${ap.title} (${ap.formative_zone})`,
        key: ap.id,
        formative_zone: ap.formative_zone,
        formative_zone_code: ap.formative_zone_code
    }))
    const showMultipleAps = academicPrograms.length > 1 && !isSameFormativeZone(academicPrograms)
    const [academicProgram, setAcademicProgram] = useState(academicPrograms[0]);
    const is_special_academic_program = special_academic_programs.includes(academicProgram.key) || special_academic_big_data_cybersecurity.includes(academicProgram.key)
    const emptyPracticesList = printLinks(fct(), `${academicProgram.formative_zone_code}${is_special_academic_program ? '_SPECIAL' : ''}`, lang).every(practice => practice === null)

    const handleCicleSelect = (e) => {
        if (e.target.value) {
            const ap = academicPrograms.find(ap => ap.key === Number(e.target.value));
            setAcademicProgram(ap)
        }
    }

    const semesters = [
        ...new Set(
            (student_meta?.coursing_or_finished_enrolls || [])
                .map(enroll => {
                    const title = enroll.academic_section_title || ''

                    if (title.includes('S1')) return 1
                    if (title.includes('S2')) return 2

                    return null
                })
                .filter(Boolean)
                .sort((a, b) => a - b)
        )
    ]

    const hasSpecializationCourse = student_meta?.enrolled_academic_programs?.some(enroll => {
        return enroll.id === academicProgram.key && (enroll.is_specialization_course ?? false);
    });

    const hasSpecializationBigDataCybersecurity = student_meta?.enrolled_academic_programs?.some(enroll => {
        return special_academic_big_data_cybersecurity.includes(enroll.id) && (enroll.is_specialization_course ?? false);
    });

    return (
        <AppPage
            name="OnlineArea"
            title={t('Área Onliner')}
            back={history.goBack}
            className="max-width-980"
        >
            <F className="max-width-980">
                <C>
                    {showMultipleAps && (
                        <Fragment>
                            <div
                                className='font-18'>{t('Estás estudiando ciclos formativos que están sujetos a diferente normativa educativa.')}</div>
                            <div className='font-18 m-top-half'>{t('Selecciona el ciclo que desees consultar')}:</div>
                            <div className='m-top'>
                                <Select options={academicPrograms} noEmptyOption value={academicProgram.key} onChange={handleCicleSelect} required />
                            </div>
                        </Fragment>
                    )}

                    {!hasSpecializationCourse && (
                        <Fragment>
                            <div className='m-top-x2'>
                                <h2 className='font-32'>{t('Información Académica')}</h2>
                                {printLinks(getAcademicInfoBySemester(
                                    lang,
                                    academicProgram.formative_zone_code,
                                    semesters
                                ), academicProgram.formative_zone_code, lang)}
                            </div>
                            <div className='m-top-x4'>
                                <h2 className='font-32'>{t('Metodología, evaluación y pruebas finales')}</h2>
                                {printLinks(methodology(), academicProgram.formative_zone_code, lang)}
                            </div>
                        </Fragment>
                    )}

                    {hasSpecializationBigDataCybersecurity && (
                        <Fragment>
                            <div className='m-top-x2'>
                                <h2 className='font-32'>{t('Información Académica')}</h2>
                                {printLinks(academicInfo(), `${academicProgram.formative_zone_code}_SPECIAL`, lang)}
                            </div>
                        </Fragment>
                    )}

                    <div className='m-top-x4'>
                        <h2 className='font-32'>{t('El campus virtual')}</h2>
                        {printLinks(campus(), academicProgram.formative_zone_code, lang)}
                    </div>
                    {emptyPracticesList ? null :
                        <div className='m-top-x4'>
                            <h2 className='font-32'>{t('Prácticas')}</h2>
                            {printLinks(
                                fct(),
                                `${academicProgram.formative_zone_code}${is_special_academic_program ? '_SPECIAL' : ''}`,
                                lang
                            )}
                        </div>
                    }
                    <div className='m-top-x4'>
                        <h2 className='font-32'>{t('Secretaría académica')}</h2>
                        {printLinks(secretary(), academicProgram.formative_zone_code, lang)}
                    </div>
                    {/*{formativeZonePlan === 'NEW' &&*/}
                    {/*    <div className='m-top-x4'>*/}
                    {/*        <AlertBox type='warning'>*/}
                    {/*            {t('onliner_area_comming_soon')}*/}
                    {/*        </AlertBox>*/}
                    {/*    </div>*/}
                    {/*}*/}
                    {isSpanishUser(student_meta.shop_id) &&
                        <div className='m-top-x4 fit-content'>
                            <CardHelp />
                        </div>
                    }
                </C>
            </F>
        </AppPage>
    )
}
